import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import CadastroEmpresaModal from "../components/CadastroEmpresaModal";
import { listarEmpresas } from "../services/api";
import { teclaAtiva } from "../utils/teclaAtiva";

export default function SeloPage() {
  const [empresas, setEmpresas] = useState([]);
  const [cadEmpresa, setCadEmpresa] = useState(false); // popup de cadastro de empresa
  const navigate = useNavigate();
  useEffect(() => { listarEmpresas().then(setEmpresas).catch(() => setEmpresas([])); }, []);

  const certificadas = empresas
    .filter((e) => e.selo === "ra")
    .sort((a, b) => b.score - a.score);

  const criterios = [
    ["50+", "avaliações de candidatos", "amostra robusta, difícil de manipular"],
    ["90%+", "índice de resposta", "quase ninguém fica sem retorno"],
    ["90%+", "índice de solução", "os casos são efetivamente resolvidos"],
    ["7+", "nota média (0–10)", "a experiência é consistentemente boa"],
    ["70%+", "voltaria a se candidatar", "o candidato faria de novo"],
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-10">
        {/* Hero */}
        <section className="text-center">
          <div className="mx-auto inline-flex items-center gap-2 rounded-full bg-green-100 text-green-800 px-4 py-1.5 text-sm font-semibold">🏅 Selo eaiRH</div>
          <h1 className="mt-4 text-3xl md:text-4xl font-bold text-text">O <span className="text-green-600">Great Place to Apply</span> dos processos seletivos</h1>
          <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
            Assim como o <i>Great Place to Work</i> reconhece bons lugares para <i>trabalhar</i>, o <b>Selo eaiRH</b> é a
            certificação das empresas com os <b>melhores processos seletivos</b> — as que dão retorno, tratam bem e
            fariam o candidato se candidatar de novo. É conquistado por <b>dados reais</b>, não por adesão.
          </p>
        </section>

        {/* Critérios */}
        <section className="mt-10">
          <h2 className="text-xl font-bold text-text">Como uma empresa conquista o selo</h2>
          <p className="text-sm text-gray-500 mt-1">Critério público e auditável — a empresa precisa atender a <b>todos</b> simultaneamente:</p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
            {criterios.map(([num, label, desc]) => (
              <div key={label} className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm flex items-start gap-3">
                <span className="text-2xl font-extrabold text-green-600 shrink-0">{num}</span>
                <div>
                  <div className="font-semibold text-gray-900">{label}</div>
                  <div className="text-sm text-gray-500">{desc}</div>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-3 text-xs text-gray-400">
            A régua é alta de propósito: um selo só vira referência quando é <b>difícil de obter e impossível de fraudar</b>.
          </p>
        </section>

        {/* Empresas certificadas */}
        <section className="mt-12">
          <h2 className="text-xl font-bold text-text">Empresas certificadas</h2>
          {certificadas.length === 0 ? (
            <div className="mt-4 rounded-2xl border border-dashed border-gray-300 p-8 text-center text-gray-500">
              {/* ⚠️ 20/09/2026: aqui dizia "as primeiras a alcançá-lo serão referência no mercado".
                  O Nelson cortou essa moldura do convite por e-mail — "achei que era um convite a todas
                  para conquistar o selo e não uma gincana escolar" — e o convite manda a empresa para
                  ESTA página. O fato de ninguém ter o selo continua (é honesto e explica a régua alta);
                  o que sai é a corrida, porque transforma um padrão aberto numa disputa com um vencedor
                  e todo o resto perdendo. */}
              <p>Nenhuma empresa alcançou o Selo eaiRH ainda.</p>
              <p className="text-sm mt-1">A régua é a mesma para todas e segue valendo a cada período — o selo se conquista respondendo candidato.</p>
            </div>
          ) : (
            <ul className="mt-4 space-y-2">
              {certificadas.map((e) => (
                <li key={e.id} onClick={() => navigate(`/empresas/${e.slug || e.id}`)}
                  {...teclaAtiva(() => navigate(`/empresas/${e.slug || e.id}`))}
                  aria-label={`Ver reputação de ${e.nome}`}
                  className="flex items-center gap-3 cursor-pointer rounded-2xl border border-gray-200 bg-white p-4 shadow-sm hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary">
                  <span className="text-xl">🏅</span>
                  <span className="font-semibold text-gray-900 flex-1">{e.nome}</span>
                  <span className="text-sm font-bold text-green-700">{Number(e.score).toFixed(1)}</span>
                </li>
              ))}
            </ul>
          )}
        </section>

        {/* CTA empresa */}
        <section className="mt-12 rounded-2xl bg-text text-white px-6 py-6 md:px-8 md:py-8 text-center">
          <h3 className="text-xl md:text-2xl font-semibold">É de uma empresa que trata bem seus candidatos?</h3>
          <p className="mt-1 text-white/80 text-sm">Responda aos relatos, dê retorno e construa a reputação que leva ao Selo eaiRH.</p>
          <button onClick={() => setCadEmpresa(true)} className="inline-block mt-4 rounded-xl bg-orange-600 hover:bg-orange-700 px-5 py-3 font-semibold">Cadastrar minha empresa</button>
        </section>
      </main>
      <CadastroEmpresaModal open={cadEmpresa} onClose={() => setCadEmpresa(false)} />
    </div>
  );
}
